export const config = {
    //apiUrl: 'http://localhost/api/public/index.php', 
    //backendUrl: 'http://localhost/apps/admision/sol_part_evento/be.php', 
    apiUrl: 'https://api.cftestataltarapaca.cl', 
    backendUrl: 'https://apps.cftestataltarapaca.cl/admision/sol_part_evento/be.php',
    code_app: '92e7e667'
};